module.exports = __webpack_public_path__ + "img/gameshow4.1cf78f2f.svg";